function API_URL() {
    if (window.location.hostname.includes("localhost")) {
        console.log("have localhost: ", window.location.hostname);
        return 'http://localhost:8080/rest/';
    } else {
        if (window.location.hostname.includes("b2c-prod.gazella.solutions")) {
            return 'https://oga-com-prod.gazella.solutions/rest/';
        }
        else if (window.location.hostname.includes("b2c-int.gazella.solutions")) {
            return 'https://oga-com-int.gazella.solutions/rest/';
        } else {
            if (window.location.hostname.includes("b2c-integration.oga.com.bo")) {
                return 'https://com-integration.oga.com.bo/rest/';
            } else {
                if (window.location.hostname.includes("b2c.oga.com.bo")) {
                    return 'https://com.oga.com.bo/rest/';
                }
                return "";
            }
        }
    }
}
export default API_URL();



// WEBPACK FOOTER //
// ./src/utils/HttpClient/apiRest.js